module.exports = __webpack_public_path__ + "img/BT.b96ba9b1.png";